<template>
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div>
        <!-- Toggle Sidebar -->
        <!-- Layout API, functionality initialized in Template._uiApiLayout()-->
        <button
          type="button"
          class="btn btn-alt-secondary me-1"
          data-toggle="layout"
          data-action="sidebar_toggle"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <!-- END Toggle Sidebar -->
      </div>
      <!-- END Left Section -->
      <!-- Right Section -->
      <div>
        <div
          v-if="store.state.devices.length > 0"
          class="dropdown d-inline-block"
          style="margin-right: 10px"
        >
          <button
            type="button"
            class="btn btn-alt-secondary dropdown-toggle"
            id="dropdown-default-light"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i
              v-if="store.state.deviceActive"
              class="mx-1 nav-main-link-icon fa fa-signal text-success"
            ></i>
            <i v-else class="mx-1 nav-main-link-icon fa fa-times text-danger"></i>

            <span class="device-name">
              {{ store.state.selectedDevice.name }}
            </span>
          </button>

          <div
            class="dropdown-menu dropdown-menu-end p-0"
            aria-labelledby="page-header-user-dropdown"
          >
            <div
              class="bg-primary-dark rounded-top fw-semibold text-white text-center p-4"
            >
              Dispositivos
            </div>

            <div
              class="p-1"
              v-for="(device, index) in store.state.devices"
              :key="device._id"
            >
              <a
                class="dropdown-item"
                style="cursor: pointer"
                @click="selectDevice(index)"
              >
              <span v-if="device.name == store.state.selectedDevice.name">
                <i  class="mx-1" :class="[store.state.deviceActive ? 'fa fa-signal text-success' : 'fa fa-times text-danger']" >
                </i>
                {{ device.name }}
              </span>
              <span v-else >
                <i class="fa fa-microchip me-1"></i> {{ device.name }}
              </span>
              </a>
              <div
                v-if="index < store.state.devices.length - 1"
                role="separator"
                class="dropdown-divider"
              ></div>
            </div>
          </div>
        </div>

        <!-- User Dropdown -->
        <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn btn-alt-secondary"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-fw fa-user"></i>
            <i
              class="fa fa-fw fa-angle-down opacity-50 ms-1 d-none d-sm-inline-block"
            ></i>
          </button>
          <div
            class="dropdown-menu dropdown-menu-end p-0"
            aria-labelledby="page-header-user-dropdown"
          >
            <div
              class="bg-primary-dark rounded-top fw-semibold text-white text-center p-3"
            >
              Opciones
            </div>
            <div class="p-2">
              <!-- <router-link class="dropdown-item" :to="{ name: 'settings' }">
                <i class="fa fa-users-cog me-1"></i> Configurar
              </router-link>
              <div role="separator" class="dropdown-divider"></div> -->
              <a
                @click="
                  showAlertConfirm(
                    'Sesión',
                    '¿Está seguro de cerrar la sesión?',
                    'question',
                    'logout'
                  )
                "
                class="dropdown-item"
                style="cursor: pointer"
              >
                <i class="fa fa-sign-out-alt me-1"></i> Salir
              </a>
            </div>
          </div>
        </div>
        <!-- END User Dropdown -->
        <!-- Notifications Dropdown -->
        <div class="dropdown d-inline-block" style="margin-left: 10px">
          <button
            type="button"
            class="btn btn-alt-secondary"
            id="page-header-notifications-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-fw fa-bell"></i>
            <span
              v-if="store.state.newNotificationStatus"
              class="notification-badge"
            >
            </span>
          </button>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
            aria-labelledby="page-header-notifications-dropdown"
          >
            <div
              class="bg-primary-dark rounded-top fw-semibold text-white text-center p-3"
            >
              Notificaciones
            </div>
            <ul class="nav-items my-2">
              <li
                v-for="(notification, index) in store.state.notifications.slice(
                  0,
                  3
                )"
                v-bind:key="index"
              >
                <router-link
                  class="d-flex text-dark py-2"
                  :to="{ name: 'notifications' }"
                >
                  <div class="flex-shrink-0 mx-3">
                    <a
                      @click="
                        notificationReaded(
                          notification._id,
                          !notification.readed
                        )
                      "
                    >
                      <i
                        v-if="notification.readed"
                        class="fa fa-fw fa-eye text-success"
                      ></i>
                      <i v-else class="fa fa-fw fa-eye-slash text-danger"></i>
                    </a>
                  </div>
                  <div class="flex-grow-1 fs-sm pe-2">
                    <div class="fw-semibold">
                      <b>Dispositivo: </b> {{ notification.deviceName }} <br />
                      <b>Variable: </b> {{ notification.variableFullName }}
                      <br />
                      <b>Condicion: </b> {{ notification.condition }} <br />
                      <b>Limite: </b> {{ notification.value }} <br />
                      <b>Valor: </b> {{ notification.payload.value }}
                    </div>

                    <div class="text-muted">
                      {{ unixToDate(notification.time) }}
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
            <div class="p-2 border-top">
              <router-link
                :to="{ name: 'notifications' }"
                class="btn btn-alt-primary w-100 text-center"
              >
                <i class="fa fa-fw fa-eye opacity-50 me-1"></i> Ver Todas
              </router-link>
            </div>
          </div>
        </div>
        <!-- END Notifications Dropdown -->
      </div>
      <!-- END Right Section -->
    </div>
    <!-- END Header Content -->
  </header>
</template>

<script>
import useApp from "@/composables/useApp";
import { onMounted, ref, inject } from "vue";
import { useStore } from "vuex";
import emitter from "@/eventBus";
import useNotifications from "@/composables/useNotifications";
export default {
  name: "Header",
  setup() {
    const store = useStore();
    let selectedDevice = ref(null);
    onMounted(() => {
      store.dispatch("getDevices");
      store.dispatch("getNotifications");
      emitter.on("selectedDeviceIndex", (index) => {
        selectedDevice.value = index;
      });
    });
    const { selectDevice, logOut, unixToDate } = useApp();
    const swal = inject("$swal");
    const { notificationReaded } = useNotifications();
    const showAlertConfirm = (title, text, icon, funct) => {
      swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          if (funct == "logout") {
            logOut();
          }
        }
      });
    };

    return {
      showAlertConfirm,
      store,
      selectDevice,
      unixToDate,
      notificationReaded,
    };
  },
};
</script>
<style>
.notification-badge {
  position: relative;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 50%;
  border: 2px solid white; /* Para dar un borde blanco y que se vea mejor */
}
.device-name {
  white-space: nowrap;
}

@media (max-width: 576px) {
  .device-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
</style>
